






import { Component, Vue } from "vue-property-decorator";
import LoginCard from "@/components/login/LoginCard.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import { AssetRepository, AssetEnum } from "@/lib/AssetRepository";
import { PartnerModule } from "../store/modules/partner";

@Component({
  components: { TheLayoutPortal, LoginCard }
})
export default class Login extends Vue {
  logo = AssetRepository.getAsset(false, AssetEnum.mmmint);
  title = "Login";
  text = "Jetzt einloggen, um Zugang zum Partnerbackend zu erhalten und Schadensmeldungen zu verwalten.";
  onLoginFunction = async () => {
    await PartnerModule.getPartners();
    await PartnerModule.setPartner(PartnerModule.partners[0]);
    this.$router.push({ path: "/" });
  };
}
